import { Box, FormControl, MenuItem, Select, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getStatusColor } from "./helper";
import { trimmedDate } from "utils/helper";
import dayjs from "dayjs";

const StatusCell = ({
  id,
  field,
  value,
  row,
  updateTrackerStatus,
  completionDateField,
}) => {
  const [currentValue, setCurrentValue] = useState(value || "");

  useEffect(() => {
    setCurrentValue(value || row?.[field] || "");
  }, [value, row, field]);

  const availableStatuses =
    field === "adv_chart_status"
      ? [
          "In-progress",
          "Practice Clarification",
          "Outreach Needed",
          "Walk-In",
          "Completed",
          "N/A",
        ]
      : ["In-progress", "Practice Clarification", "Completed", "N/A"];

  const handleChange = async (event) => {
    const newValue = event.target.value;
    setCurrentValue(newValue);

    let completionDate = null;
    if (newValue === "Completed") {
      completionDate = dayjs().format("MM/DD/YYYY");
    }

    await updateTrackerStatus(
      id,
      field,
      newValue,
      completionDateField,
      completionDate,
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        minHeight: "100%",
        py: 0.5,
        width: "100%",
      }}
    >
      <FormControl fullWidth variant="standard" size="small">
        <Select
          value={currentValue}
          onChange={handleChange}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return <span style={{ color: "#9e9e9e" }}>Select Status</span>;
            }
            return selected;
          }}
          sx={{
            fontWeight: "bold",
            color: currentValue ? getStatusColor(currentValue) : "#9e9e9e",
          }}
        >
          <MenuItem value={null}>
            <em>Select Status</em>
          </MenuItem>

          {availableStatuses.map((statusOption) => (
            <MenuItem key={statusOption} value={statusOption}>
              {statusOption}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {(currentValue === "Completed" || row?.[field] === "Completed") &&
        row?.[completionDateField] && (
          <Typography variant="caption" color="text.secondary" display="block">
            Compl Date: {trimmedDate(row[completionDateField])}
          </Typography>
        )}
    </Box>
  );
};

export default StatusCell;
